import ImageLightbox from "./ImageLightbox/ImageLightbox";
document.addEventListener("DOMContentLoaded", () => {
    new ImageLightbox();
});
